import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Icon, IconName, Text, IconColor, Group, TextColor } from '@as/cotopaxi';
const LimitedStockNotification = ({ skuAvailability, isOneSizeProduct, sizeCombinationNotExist, market, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    let message;
    const hasExactAvailability = () => skuAvailability.exactAvailability && skuAvailability.exactAvailability > 0;
    if (sizeCombinationNotExist) {
        if (market === 'be') {
            message = t('pdp.size.combination.be.not.exist.error');
        }
        else {
            message = t('pdp.size.combination.not.exist.error');
        }
    }
    else if (skuAvailability.isSoldOut && !isOneSizeProduct) {
        if (market === 'be') {
            message = t('product.selected.size.be.unavailable');
        }
        else {
            message = t('product.selected.size.unavailable');
        }
    }
    else if (hasExactAvailability()) {
        message = t('product.last.pieces.exact', {
            amount: skuAvailability.exactAvailability,
        });
    }
    else if (skuAvailability.lastPieces) {
        message = t('product.last.pieces');
    }
    else {
        message = '';
    }
    if (!message) {
        return null;
    }
    return (_jsxs(Group, { inline: true, children: [_jsx(Icon, { name: IconName.INFORMATION_OUTLINE, color: IconColor.NEGATIVE }), ' ', _jsx(Text, { inline: true, color: TextColor.NEGATIVE, children: message })] }));
};
export default LimitedStockNotification;
